import WithLoadingErrorWrapper from '@/components/with-loading-error-wrapper';
import { useClientPermissions } from '@/hooks/use-client-permissions';
import { DashboardHome, PublicDashboardHome } from '@/constants';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';

export const PublicTenantRoutes = () => {
  const { tenant } = useParams<{ tenant: string }>();
  const location = useLocation();
  const { isSuperAdmin, isLoading } = useClientPermissions();

  if (tenant !== 'public') {
    return <Navigate to={`/${tenant}/dashboard`} replace />;
  }

  return (
    <WithLoadingErrorWrapper
      loading={isLoading}
      isFetching={false}
      error={null}
    >
      {isSuperAdmin ? (
        <Outlet />
      ) : (
        <Navigate to={`/${tenant}/profile`} replace state={{ from: location }} />
      )}
    </WithLoadingErrorWrapper>
  );
};

export const TenantDashboardRoute = () => {
  const { tenant } = useParams<{ tenant: string }>();
  const { isSuperAdmin } = useClientPermissions();

  if (tenant === 'public' && isSuperAdmin) {
    return <PublicDashboardHome />;
  }

  return <DashboardHome />;
};
